// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddContentField_wrapper__2a8Te","icon":"AddContentField_icon__10d9J","text":"AddContentField_text__3YQiV"};